import { render, staticRenderFns } from "./ConfirmEmail.vue?vue&type=template&id=12a20a84&scoped=true&"
import script from "./ConfirmEmail.vue?vue&type=script&lang=js&"
export * from "./ConfirmEmail.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmEmail.vue?vue&type=style&index=0&id=12a20a84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a20a84",
  null
  
)

export default component.exports